import { render, staticRenderFns } from "./ed-class-schedule.component.vue?vue&type=template&id=9cce8ad4&scoped=true&"
import script from "./ed-class-schedule.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule.component.scss?vue&type=style&index=0&id=9cce8ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cce8ad4",
  null
  
)

export default component.exports